import { IColumns } from '../../../../components/Table'

export type BankAccountsColumnKeys = 'id' | 'currency' | 'bankName' | 'bankAccountNumber' | 'actions'

export const columns: IColumns<BankAccountsColumnKeys>[] = [
  {
    id: 'id',
    label: 'ID',
  },
  {
    id: 'currency',
    label: 'CURRENCY',
  },
  {
    id: 'bankName',
    label: 'BANK NAME',
  },
  {
    id: 'bankAccountNumber',
    label: 'BANK ACCOUNT NUMBER',
  },
  {
    id: 'actions',
    label: 'ACTION',
  },
]

export const modalColumns: IColumns<BankAccountsColumnKeys>[] = [
  {
    id: 'bankName',
    label: 'BANK NAME',
  },
  {
    id: 'currency',
    label: 'CURRENCY',
  },
  {
    id: 'bankAccountNumber',
    label: 'ACCOUNT NUMBER',
  },
  {
    id: 'actions',
    label: '',
  },
]
